if (!customElements.get('gallery-video-unmute')) {
  class GalleryVideoUnmute extends HTMLElement {
    connectedCallback() {
      this.addEventListener('click', this.handleClick.bind(this));
      this.addEventListener('keydown', this.handleKeydown.bind(this));
      document.addEventListener('gallery-video:unmute-request', this.handleUnmuteRequest.bind(this));
    }

    handleKeydown(e) {
      if (e.key === 'Enter' || e.key === ' ') {
        e.preventDefault();
        this.handleClick(e);
      }
    }

    handleClick(e) {
      e.preventDefault();
      e.stopPropagation();

      const video = this.findVideo();
      if (!video) return;

      const goingMuted = !video.muted;

      if (!goingMuted) {
        document.dispatchEvent(new CustomEvent('gallery-video:unmute-request', {
          detail: { source: this }
        }));
      }

      this.applyMuted(goingMuted, video);
    }

    handleUnmuteRequest(e) {
      if (e.detail && e.detail.source === this) return;
      this.applyMuted(true);
    }

    findVideo() {
      const item = this.closest('.gallery__item');
      return item ? item.querySelector('video') : null;
    }

    applyMuted(muted, video) {
      const v = video || this.findVideo();
      if (v) v.muted = muted;
      this.dataset.muted = muted ? 'true' : 'false';
      const label = muted ? this.dataset.labelUnmute : this.dataset.labelMute;
      if (label) this.setAttribute('aria-label', label);
    }
  }

  customElements.define('gallery-video-unmute', GalleryVideoUnmute);
}
